import { useState, useEffect, DOMAttributes, CSSProperties } from 'react'
import {
  Segment as SemanticSegment,
  StrictSegmentProps as SemanticSegmentProps,
} from 'semantic-ui-react'

import { Icon } from '../'
import { StyledSegmentGroup, SegmentWrapper, ClickableRow } from './Styles'

interface SegmentProps extends SemanticSegmentProps {
  noMargin?: boolean
  expandable?: boolean
  expandableHeading?: string
  openByDefault?: boolean
  dangerouslySetInnerHTML?: DOMAttributes<any>['dangerouslySetInnerHTML']
  style?: CSSProperties
  onClick?: () => void
  [x: string]: any
}

const Segment = ({
  noMargin,
  children,
  expandable,
  expandableHeading,
  openByDefault,
  dangerouslySetInnerHTML,
  ...props
}: SegmentProps) => {
  const [expanded, setExpanded] = useState(openByDefault)

  useEffect(() => {
    setExpanded(openByDefault)
  }, [openByDefault])

  if (dangerouslySetInnerHTML) {
    return (
      <SemanticSegment
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...props}
      />
    )
  }

  return (
    <SegmentWrapper {...props}>
      {expandable && (
        <ClickableRow onClick={() => setExpanded(!expanded)}>
          <span>{expandableHeading}</span>
          <Icon
            button
            size="large"
            name={expanded ? 'icon-fold-up' : 'icon-fold-down'}
          />
        </ClickableRow>
      )}

      {!expandable && children}

      {expandable && expanded && children}
    </SegmentWrapper>
  )
}

Segment.Group = StyledSegmentGroup

export default Segment
